import { PANEL_CHAT_WIDTH_PX } from '../../panel-chat.constants';

/** Layout constants for a workflow editor with the builder agent beside it. Every host mounts the
 * same layout, so these live here rather than per app. */
export class WorkflowBuilderLayoutHelper {
  /** The agent column's width: the side-panel chat's, so it reads the same as every other panel. */
  static readonly AGENT_COLUMN_WIDTH_PX = PANEL_CHAT_WIDTH_PX;

  /** The editor fills its card rather than the viewport, because the layout pads the page. */
  static readonly EDITOR_ROOT_CLASS_NAME =
    'flex h-full min-h-0 w-full flex-col bg-bg-secondary';

  /** The card the editor sits in, on the page's light fill beside the agent column. */
  static readonly EDITOR_CARD_CLASS_NAMES =
    'overflow-hidden rounded-md border border-border-primary bg-bg-primary shadow-xs';
}
